import { produce } from "immer";

import {
  PlansActionsTypes,
  PlansReducerActions,
  PlansState
} from "../types/Plans.reducer.types";

const INITIAL_STATE: PlansState = {
  list: undefined,
  isLoadingList: false,
  message: undefined
};

export default function reducer(
  state = INITIAL_STATE,
  action: PlansReducerActions
): PlansState {
  return produce(state, draft => {
    switch (action.type) {
      case PlansActionsTypes.CREATE_REQUEST: {
        draft.message = undefined;
        break;
      }

      case PlansActionsTypes.CREATE_FAIL: {
        draft.message = action.payload.message;
        break;
      }

      case PlansActionsTypes.CREATE_SUCCESS: {
        draft.message = action.payload.message;
        break;
      }

      case PlansActionsTypes.DISMISS_MESSAGE: {
        draft.message = undefined;
        break;
      }

      case PlansActionsTypes.EDIT_REQUEST: {
        draft.message = undefined;
        break;
      }

      case PlansActionsTypes.EDIT_FAIL: {
        draft.message = action.payload.message;
        break;
      }

      case PlansActionsTypes.EDIT_SUCCESS: {
        draft.message = action.payload.message;
        break;
      }

      case PlansActionsTypes.LIST_REQUEST: {
        draft.isLoadingList = true;
        draft.list = undefined;
        break;
      }

      case PlansActionsTypes.LIST_FAIL: {
        draft.isLoadingList = false;
        draft.list = undefined;
        break;
      }

      case PlansActionsTypes.LIST_SUCCESS: {
        draft.isLoadingList = false;
        draft.list = action.payload.list;
        break;
      }
      default:
    }
  });
}
